import React from 'react';
import { PokemonCard } from './PokemonCard';
export function PokemonGrid({
  pokemon,
  onSelectPokemon,
  isPokemonShiny,
  onToggleShiny
}) {
  if (pokemon.length === 0) {
    return <div className="text-center py-12 text-gray-300" data-id="element-298">
        <p className="text-xl" data-id="element-299">
          No Pokémon found matching your search criteria.
        </p>
        <p className="mt-2" data-id="element-300">Try adjusting your filters or search term.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-301">
      {pokemon.map(pokemon => <PokemonCard key={pokemon.id} pokemon={pokemon} onClick={() => onSelectPokemon(pokemon)} isPokemonShiny={isPokemonShiny} onToggleShiny={onToggleShiny} data-id="element-302" />)}
    </div>;
}